//
// Camel Case
//
export const camelCase = (str: string) => {
  str = str.charAt(0).toLowerCase() + str.slice(1);
  return str.replace(/[-_](.)/g, (match: any, group: any) => {
    return group.toUpperCase();
  });
};

//
// Snake Case
//
export const snakeCase = (str: string): string => {
  return str.replace(/[A-Z]/g, (s) => {
    return "_" + s.charAt(0).toLowerCase();
  });
};

const convertKeyToSnakeCase = (params: any) => {
  const jsonParams: any = {};
  for (const [key, v] of Object.entries(params)) {
    const value = v as any;
    if (v === undefined || v === null) {
      continue;
    } else if (Array.isArray(value)) {
      jsonParams[snakeCase(key)] = value;
    } else if (value.constructor.name === "File") {
      // undefined.undefinedとつなげてもエラーにはならない
      jsonParams[snakeCase(key)] = value;
    } else if (typeof value === "object") {
      const childValue = convertKeyToSnakeCase(value);
      jsonParams[snakeCase(key)] = childValue;
    } else {
      jsonParams[snakeCase(key)] = value;
    }
  }
  return jsonParams;
};

export const snakeCases = (params: any) => {
  if (params === undefined || params === null) {
    return {};
  }
  const jsonParams = convertKeyToSnakeCase(params);
  return jsonParams;
};
